module.exports = __webpack_public_path__ + "static/img/workspace-1.36f6d8b.svg";